export default "__VITE_ASSET__b8534772__"